import { createAction, createAsyncAction } from 'typesafe-actions'
import { User } from 'oidc-client-ts'

export const resetGrpAuthState = createAction('DOC / GrpAuth / reset_state')()

export const loginStart = createAction('CMD / GrpAuth / login_start')()

export const loginAsync = createAsyncAction(
    'DOC / GrpAuth / LOGIN_REQUEST',
    'DOC / GrpAuth / LOGIN_SUCCESS',
    'DOC / GrpAuth / LOGIN_FAILURE',
)<void, User, Error>()

export const setShouldConnect = createAction('DOC / GrpAuth / set_should_connect')<boolean>()

export const setSelectedDealerId = createAction('DOC / GrpAuth / set_selected_dealer_id')<string>()

export const updateUserAfterRefresh = createAction('DOC / GrpAuth / update_user_after_refresh')<User>()

export const triggerE3DReinit = createAction('CMD / GrpAuth / trigger_e3d_reinit')()
export const e3dReinitBumped = createAction('DOC / GrpAuth / e3d_reinit_bumped')<number>()

export const setShouldConnectFromLoginComponent = createAction(
    'DOC / GrpAuth / SET_SHOULD_CONNECT_FROM_LOGIN_COMPONENT',
)<boolean>()
export const setIsLoading = createAction('CMD / GrpAuth / set_loading')<boolean>()
export const logout = createAction('DOC / GrpAuth / logout')()
